const screens = [
  {
    id: "home",
    path: "Home",
    index: true,
  },
  {
    id: "choose-game",
    path: "ChooseGame",
  },
  {
    id: "join-room",
    path: "JoinRoom/index",
  },
  {
    id: "room",
    path: "Room",
  },
  {
    id: "game-speed",
    path: "GameSpeed/index",
  },
  {
    id: "game-reaction",
    path: "GameReaction/index",
  },
  {
    id: "game-coordination",
    path: "GameCoordination/index",
  },
];

const errorScreen = {
  id: "error",
  path: "Error",
  error: true,
};

export { screens, errorScreen };
